<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">Validation Failures</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>

<div class="modal-body" hsDraggable="modal-dialog">
  <ng-container>
    <nf-table-layout
      class="table"
      hideTitle
      hideClearAll
      hideSearch
      [gridOptions]="gridOptions"
      [data]="failedAccounts"
    ></nf-table-layout>
  </ng-container>
</div>
